/**
 * documentAttribute Normalizr Schema
 */

import { schema } from 'normalizr';

const documentAttribute = new schema.Entity('documentAttributes');

export default documentAttribute;
